import React, { useContext, createContext } from 'react'
import TimeTableContext from '../../context/timeTableContext'

const ChangeBox = ({ change, clean }) => {
  const context = useContext(TimeTableContext);
  let changeElem
  let boxTime
  let currentSubject
  let currentTeacher
  let currentRoom
  let showChanges
  if (!clean) {
    if (change.teacher_out) {
      let changeTeacher = change.teacher_in ? (
        <span><b>ממלא/ת מקום - </b>{change.teacher_in}</span>
      ) : (
        ''
      )

      changeElem = (
        <div className='alert alert-info'>
          <span>
            שיעור - {change.hour} , כיתה {change.current_class}{' '}
          </span>
          <b>החלפת מורה</b>
          <br />
          <span className='badge badge-danger badge-teacher'>
            <strike>{change.teacher_out} </strike>
          </span>
          <span className='badge badge-success badge-teacher'>
            {changeTeacher}
          </span>
        </div>
      )
    } else if (change.newDay) {
      changeElem = (
        <div className='alert alert-warning'>
          <span>
            שיעור - {change.hour} , כיתה {change.current_class}{' '}
          </span>
          <b>העברת שיעור</b> - {change.subject}
          <br />
          <span className='badge badge-success badge-teacher'>
            הועבר {change.newDay} שעה {change.newHour}
          </span>
        </div>
      )
    } else if (change.void_reason) {
      changeElem = (
        <div className='alert alert-danger'>
          <span>
            שיעור - {change.hour}, כיתה {change.current_class}{' '}
          </span>
          <b>ביטול שיעור</b> - {change.subject}
          <br />
          <span className='badge badge-danger badge-teacher'>
            {change.void_reason}
          </span>
        </div>
      )
    } else {
      changeElem = <div />
    }

    return changeElem
  } else {
    showChanges = context.state.currentScreen === 5
    if(change){
      //console.log(change)
      currentSubject = <span>
      <h6> {change.subject} </h6>
      </span>

      currentTeacher = <div className="teahers-list"> 
      {change.teachers}
      </div>
      
      
      currentRoom = change.room_name != "" ? <div className="room-info">חדר: {change.room_name}</div> : <div></div>
    }
    
    //console.log(currentClass)
    if (change.teacher_out && showChanges) {
     
      let changeTeacher = change.teacher_in ? (
        
        <span className="badge badge-success badge-teacher">{change.teacher_in}</span>
      ) : (
        ''
      )
      
      changeElem = (
        <div class="box-changes-inner">
          {currentSubject}
          <span className="badge badge-danger badge-teacher"><strike>{change.teacher_out}</strike></span>
          <br />
          {changeTeacher}
        </div>
      )
    } else if (change.newDay && showChanges) {
      console.log(change)
      changeElem = (
        <div class="box-changes-inner">
          {currentSubject}
          {currentTeacher}
          <div className="badge badge-danger">
          השיעור הועבר ל - {change.newDay} שעה {change.newHour}
          </div>
        </div>
      )
    } else if (change.day && !change.void_reason && showChanges) {
      changeElem = (
        <div class="box-changes-inner">
          {currentSubject}
          {currentTeacher}
          <div className="badge badge-success">
          השיעור הועבר מ - {change.day} שעה {change.hour}
          </div>
        </div>
      )
    } else if (change.void_reason && showChanges) {
      changeElem = (
        <div class="box-changes-inner">
          {currentSubject}
          {currentTeacher}
          <span className="badge badge-danger badge-teacher">
            ביטול שיעור
          <br />
          {change.void_reason}
          </span>
        </div>
      )
    } else {
      changeElem = <div class="box-changes-inner">
        {currentSubject}
        {currentTeacher}
        {currentRoom}
      </div>
    }

    return changeElem
  }
}

export default ChangeBox
